import { Moment } from 'moment';

export class AllocationInterval {
    startTime: Moment;
    endTime: Moment;
  }
